module.exports = __webpack_public_path__ + "fonts/LineIconsPro Light.9a9b66a.woff2";